import { useEffect, useState } from 'react';
import { useAuth } from '../../../authContext';
import { getEmbeddedSignupByPhone } from '../../../api/login.service';
import InstagramTools from './InstagramTools';

type Screen = 'comments' | 'publish' | 'insights';

export default function InstagramPage({ screen }: { screen: Screen }) {
  const { displayPhoneNumber } = useAuth();
  const [businessIgId, setBusinessIgId] = useState('');
  const [status, setStatus] = useState<'loading' | 'ready' | 'missing'>('loading');

  useEffect(() => {
    const phone = displayPhoneNumber || sessionStorage.getItem('display_phone_number') || '';
    if (!phone) {
      setStatus('missing');
      return;
    }
    setStatus('loading');
    getEmbeddedSignupByPhone(phone)
      .then((data) => {
        const record = (data?.records || []).find((item) => item.instagramUserId) || data?.records?.[0];
        const assignedId = record?.instagramUserId ? String(record.instagramUserId) : '';
        setBusinessIgId(assignedId);
        setStatus(assignedId ? 'ready' : 'missing');
      })
      .catch(() => {
        setBusinessIgId('');
        setStatus('missing');
      });
  }, [displayPhoneNumber]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="px-6 py-8">
        {status === 'loading' ? (
          <p className="text-sm text-gray-500">Loading the Instagram account assigned to this user...</p>
        ) : status === 'missing' ? (
          <p className="text-sm text-gray-700">Choose an Instagram account in Settings, then open this page again.</p>
        ) : (
          <InstagramTools screen={screen} businessIgId={businessIgId} />
        )}
      </div>
    </div>
  );
}
